import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

function ScrollToTop({ history }) {
  useEffect(() => {
    const unlisten = history.listen((location) => {
      window.scrollTo(0, 0);

      // Handle noindex for project pages
      const projectPaths = [
        '/amazon', '/mymic', '/covid', '/seed', '/ROTC', '/CivicLab', 
        '/NYCA', '/Fatherhood', '/Repatriation', '/emailScanner', 
        '/DTE', '/wydot', '/socalren', '/gp', '/smokefree', '/datim', 
        '/ncbiVirus', '/ClinicalInfo', '/CB', '/coswd', '/bge', 
        '/nationalgrid', '/sightline'
      ];

      const isProjectPage = projectPaths.some(path => 
        location.pathname.toLowerCase() === path.toLowerCase()
      );

      let metaRobots = document.querySelector('meta[name="robots"]');
      
      if (isProjectPage) {
        if (!metaRobots) {
          metaRobots = document.createElement('meta');
          metaRobots.name = 'robots';
          document.head.appendChild(metaRobots);
        }
        metaRobots.content = 'noindex, nofollow';
      } else {
        if (metaRobots) {
          metaRobots.content = 'index, follow';
        }
      }
    });
    return () => {
      unlisten();
    };
  }, [history]);

  return null;
}

export default withRouter(ScrollToTop);